/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_AgentsInputs */

const en_mk_nav_p_agents = /** @type {(inputs: Mk_Nav_P_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agents`)
};

const id_mk_nav_p_agents = /** @type {(inputs: Mk_Nav_P_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen AI`)
};

/**
* | output |
* | --- |
* | "AI agents" |
*
* @param {Mk_Nav_P_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_agents = /** @type {((inputs?: Mk_Nav_P_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_agents(inputs)
	return en_mk_nav_p_agents(inputs)
});